import React, { useState } from "react"
import PropTypes from "prop-types"
import { Grid, Typography, TextField } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import CheckIcon from '@mui/icons-material/Check';
import { postLeadWithoutLoginFetch } from "../../fetch/index/agentNew"

import { checkEmail, checkPhone } from "../../commons/helps";
const LeadsFormComponent = (props) => {

    const { leadsWeclome, leadsInfo, converationId } = props;
    const [loading, setLoading] = useState(false);
    const [newLeadsInfo, setNewLeadsInfo] = useState(leadsInfo)
    const [buttonDisabled, setButtonDisabled] = useState(false)
    const formDisabled = () => {
        let isDisabled = false;
        newLeadsInfo.forEach(item => {
            if (item.value === "" || item.error) {
                isDisabled = true
            }
        });
        return isDisabled
    }
    const submitEventForm = async () => {
        setLoading(true)

        let data = {}
        newLeadsInfo.forEach(item => {
            data[item.key] = item.value;
        })
        try {
            await postLeadWithoutLoginFetch(converationId, data)
            localStorage.setItem("leads", true)
            setButtonDisabled(true)
        } catch (error) {

        }
        setLoading(false)
    }
    const leadsInfoCallBack = (index, value) => {
        const newValue = JSON.parse(JSON.stringify(newLeadsInfo))
        newValue.forEach((item, key) => {
            if (key === index) {
                item.value = value;
                if (item.key === "email" && !checkEmail(item.value)) {
                    item.error = "Please check if the email format is correct";
                } else if (item.key === "email" && checkEmail(item.value)) {
                    item.error = false;
                } else if (item.key === "phone" && !checkPhone(item.value)) {
                    item.error = "Please check if the phone format is correct";
                } else if (item.key === "phone" && checkPhone(item.value)) {
                    item.error = false;
                }
            }
        });
        setNewLeadsInfo(newValue)
    }

    return (
        <Grid sx={{ width: "60%" }}>
            <Typography variant="subtitle1" sx={{ marginTop: "10px" }}>{leadsWeclome}</Typography>
            <Typography variant="subtitle1" sx={{ opacity: 0, height: "10px" }}>Build a custom GPT, embed it on your website and let it handle customer support, lead generation, engage with your users, and more.</Typography>

            <Grid sx={{ width: "100%" }}>
                {
                    newLeadsInfo?.map?.((item, index) => {
                        return (
                            <Grid key={index} sx={{ marginTop: "20px", width: "100%" }}>
                                <TextField
                                    sx={{ width: "100%" }}
                                    disabled={buttonDisabled}
                                    inputProps={{ maxLength: 60 }}
                                    size="small"
                                    label={item.label}
                                    variant="outlined"
                                    error={Boolean(item.error)}
                                    // helperText={item.error}
                                    InputProps={{
                                        startAdornment: <></>,
                                    }}
                                    onChange={(e) => {
                                        leadsInfoCallBack(index, e?.target?.value)
                                    }}
                                />

                            </Grid>

                        )
                    })
                }
            </Grid>
            <Grid sx={{ marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
                <LoadingButton
                    size='small'
                    loading={loading}
                    loadingPosition="start"
                    startIcon={<CheckIcon />}
                    variant="contained"
                    color={"inherit"}
                    onClick={submitEventForm}
                    disabled={formDisabled() || buttonDisabled}
                >
                    Submit
                </LoadingButton>
            </Grid>
        </Grid>
    );
};
LeadsFormComponent.propTypes = {
    leadsWeclome: PropTypes.any,
    leadsInfo: PropTypes.any,
    converationId: PropTypes.any,
}
export default LeadsFormComponent;